// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDVAk_YBMwBnUZTUFUia3XObLJxHVwALlo",
    authDomain: "curbside-1435d.firebaseapp.com",
    databaseURL: "https://curbside-1435d.firebaseio.com",
    projectId: "curbside-1435d",
    storageBucket: "curbside-1435d.appspot.com",
    messagingSenderId: "853045657510",
    appId: "1:853045657510:web:601998a3bf4d66f05dd967",
    measurementId: "G-7GDGCY3839"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
